import * as API from "../../api"
import * as ActionTypes from '../action-types'
import { message } from "antd"
import { REDUX } from '../../../constants'

import {
    unsetLoadingVehicleReport
} from './style'

export const get_devices_state_cms_request = (uid, sessionId, cb = () => {}) => dispatch => {
    
    Promise.all([
        API.getDevicesCMS(uid, sessionId),
        API.getDevicesStateCMS(uid, sessionId)
    ])
    .then(([devices, deviceState]) => {

        const { device = [] } = devices
        const { mdvrState = [], status } = deviceState

        const devicesDictionary = Object.fromEntries(device.map(a => [a.DeviceId, a]))
        
        const allDevices = mdvrState.map(state => ({
            ...state,
            ...devicesDictionary[state.DeviceId]
        }))

        if(status === 200) {
            dispatch(get_devices_cms_success(allDevices))
            cb(mdvrState)
        }
    })
}

const get_devices_cms_success = devices => {
    return {
        type: ActionTypes.GET_DEVICES_MDVR_STATE,
        devices
    }
}

export const create_device_mdvr_request = (items, cb = () => {}) => dispatch => {

    API
    .createDeviceMDVR(
        items
    )
    .then(info => {
        const { device, status, msg } = info

        if(status === 200) {
            dispatch(create_device_mdvr_success(device))
            cb()
        } else if(status === 401) {
            message.warning(`Failed in creating device. Error: ${msg}`)
        } else {
            message.warning('Failed in creating device. Retry?')
        }

    })
    .finally(() => {
        // cb()
    })
}

const create_device_mdvr_success = (device) => {
    return {
        type: ActionTypes.CREATE_DEVICE_MDVR,
        device
    }
}

export const update_device_mdvr_request = (items, cb = () => {}) => dispatch => {

    API
    .updateDeviceMDVR(
        items
    )
    .then(info => {
        const { mobileDeviceVideoRecorder, status, msg } = info

        if(status === 200) {
            dispatch(update_device_mdvr_success({ ...mobileDeviceVideoRecorder, ...items.device }))
            message.success(msg)
            cb()
        } else if(status === 401) {
            message.warning(`Failed in updating device. Error: ${msg}`)
        } else {
            message.warning('Failed in updating device. Retry?')
        }

    })
    .finally(() => {
        // cb()
    })
}

const update_device_mdvr_success = (device) => {
    return {
        type: ActionTypes.UPDATE_DEVICE_MDVR,
        device
    }
}

export const get_passenger_count_request = (vid, startTime, endTime) => dispatch => {
    
    API
    .getPassengerCount({
        vid,
        startTime,
        endTime
    })
    .then(info => {

        const { status, passengerCount, msg } = info

        if(status === 200) {
            dispatch(get_passenger_count_success(passengerCount))
            
            if(!passengerCount?.length) {
                message.error('No data available!')
            } 
        } else {
            message.error(msg)
        }
    })
}

const get_passenger_count_success = (passengerCount) => {
    return {
        type: ActionTypes.GET_PASSENGER_COUNT,
        passengerCount
    }
}


export const unset_passenger_count_success = () => {
    return {
        type: ActionTypes.UNSET_PASSENGER_COUNT
    }
}

export const get_device_mdvr_event_request = (vid, startTime, endTime, sessionId) => dispatch => {

    API
    .getDeviceMDVREvent({
        vid,
        startTime,
        endTime, 
        sessionId
    })
    .then(info => {

        const { status, mdvrEvents = [], msg, Reason } = info || {}

        if(status === 200) {
            dispatch(get_device_mdvr_success(mdvrEvents))
            
            if(!mdvrEvents.length) {
                message.error('No data available!')
            }
        } else {
            message.error(msg || Reason)
        }
    })
    .finally(() =>{
        dispatch(unsetLoadingVehicleReport())
    })
}

const get_device_mdvr_success = (mdvrEvents) => {

    return {
        type: ActionTypes.GET_MDVR_EVENT,
        mdvrEvents
    }
}

export const unset_device_mdvr_success = () => {

    return {
        type: ActionTypes.UNSET_MDVR_EVENT
    }
}


/**
 * Get Devices
 */

 export const get_devices_mdvr_request = mdvrids => dispatch => {

    let mdvridBatch = []

    mdvrids.map((vid, index) => {

        mdvridBatch.push(vid)

        if( 
            (index+1) % REDUX.REDUX_DEVICE_BATCH_GET_SIZE === 0
            ||
            index+1 === mdvrids.length
        ) {
            dispatch(batch_get_devices_mdvr_request(mdvridBatch))
            mdvridBatch = []
        }

        return null
    })
 }

/**
 * Batch Get Device
 */
 export const batch_get_devices_mdvr_request = mdvrids => dispatch => {

    API
    .getDeviceMDVRInfoBatch(mdvrids)
    .then(info => {
        try {
            const {
                mobileDeviceVideoRecorders
            } = info

            dispatch(batch_get_devices_mdvr_success(mobileDeviceVideoRecorders))


        } catch(err) {
            message.error('Error in batch getting devices. Refresh page?')
        }

    })
}

const batch_get_devices_mdvr_success = (mobileDeviceVideoRecorders) => {
    return {
        type: ActionTypes.GET_DEVICES_MDVR,
        mobileDeviceVideoRecorders
    };
}


export const get_device_disconnected_request = (vids, startTime, endTime) => dispatch => {
    API
    .getDisconnectedDeviceByVID({
        vids,
        startTime,
        endTime
    })
    .then(info => {

        const { status, msg, report } = info

        if(status === 200) {
            dispatch(get_device_disconnected_success(report))
        } else {
            message.error(msg)
        }
    })
}

const get_device_disconnected_success = (report) => {
    return {
        type: ActionTypes.GET_DEVICES_DISCONNECTED,
        report
    }
}